import type { ServiceDict } from '~/API/externals'
import { createActionCreator } from '../common/actions'

export const FetchedHostDirectory = createActionCreator<{
    hosts: ServiceDict
}>('FETCHED_HOST_DIRECTORY')
